import { GlobalStyle } from './GlobalStyle.style';

export default GlobalStyle;
